document.addEventListener("DOMContentLoaded", function () {
  var interval = setInterval(function () {
    const owlItems = document.querySelectorAll(".owl-item .evm-ws-card");
    if (owlItems.length) {
      owlItems.forEach((owlItem, index) => {
        const dataId = owlItem.querySelector('.evm-ws-image-wrapper').getAttribute("data-pid");
        const nameProductId = owlItem.querySelector('.ws-card__header-link').getAttribute("href");

        owlItem.classList.add('product-item');
        if (nameProductId) {
          fetchProductData(nameProductId, dataId, owlItem);
        }
        if (!dataId) return;
      });
      clearInterval(interval);
    }
  }, 500);
});

$(function() {
  $(document).on('click', '.get-image-variant', function(e) {
    const productHandle = $(this).data('product-handle');
    const productUrl = `${window.location.origin}/products/${productHandle}.json`;
    const title = $(this).attr('title');
    const element = $(this);
    $.ajax({
      url: productUrl,
      method: 'GET',
      success: function (response) {
        const variants = response.product.variants;
        const images = response.product.images;
        var image_id = '';
        var variant_id = '';
        for (let variant of variants) {
          console.log(variant);
          if (variant.option1 == title) {
            image_id = variant.image_id;
            variant_id = variant.id;
            break;
          }
        }
        if (!image_id) {
          return;
        }

        var image_link = '';
        for (let image of images) {
          console.log(image);
          if (image.id == image_id) {
            image_link = image.src;
            break;
          }
        }
        if (!image_link) {
          return;
        }

        element.parents('.evm-ws-card').find('button.show-product-quick-view-custom').attr('data-product-variant', variant_id);
        element.parents('.product-item__inner').find('button.product-item__quick-view-button').attr('data-product-variant', variant_id);
        
        element.parents('.evm-ws-card').find('.ws-card__background-image').attr('style', "background-image: url('"+ image_link +"');");
        element.parents('.product-item__inner').find('.product-item__image--one img').attr({'src': image_link, 'srcset': image_link});
      },
      error: function (xhr, status, error) {
        console.error("Error fetching product data:", error);
      }
    });
  })
});

function fetchProductData(nameProductId, dataId, owlItem) {
  fetch(`${nameProductId}.js`)
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then(product => {
      if (product.variants.length > 0) {
        const variantId = product.variants[0].id;
        const wishlist = createWishlistButton(dataId, variantId);
        const quickView = createQuickViewButton(product);
        // const variantItem = createVariantSwatches(product);

        owlItem.querySelector('.evm-ws-image-wrapper').appendChild(wishlist);
        owlItem.querySelector('.evm-ws-image-wrapper').appendChild(quickView);
        allHulkWishlistButtons = Array.from(document.querySelectorAll("[data-wishlist]"));
        window.HulkappWishlist._checkForProductStatus(allHulkWishlistButtons, "multiple");

        const quickViewButtons = owlItem.querySelectorAll('button.show-product-quick-view-custom');
        quickViewButtons.forEach(button => {
          const productHandle = button.getAttribute('data-product-handle');
          const productUrl = `${window.location.origin}/products/${productHandle}?view=quick-view`;

          if (productHandle) {
            $.ajax({
              url: productUrl,
              method: 'GET',
              success: function (response) {
                // Find the color swatches container
                const colorSwatches = $(response).find('.product__color-swatches--inner');

                // Add custom classes to the color swatches container
                colorSwatches.addClass('dynamic-variant-input-wrap custom-variant-quick-view');

                // Get all color swatch items
                const colorSwatchItems = colorSwatches.find('button.product__color-swatch');

                // Create the outermost container div
                const swatchesContainer = $('<div data-product-item-element-visible-only-for-mode="grid" class="product-swatches-container"></div>');

                // Create a wrapper for the color swatches options
                const swatchesWrapper = $('<div class="product-swatches-options"></div>');
                const ulElement = $('<ul class="product-swatches-options__list ff-body fs-body-50"></ul>');
                swatchesWrapper.append(ulElement);

                // Display only the first 5 items
                colorSwatchItems.each((index, button) => {
                  if (index < 5) {
                    const liElement = $('<li></li>');
                    const link = $('<a class="product-swatches-options__item get-image-variant"></a>');
                    link
                      .attr('data-product-handle', product.handle) // Add the product handle to the link
                      .attr('data-swatch-shape', 'round') // Add the missing attribute
                      .attr('data-product-variant', 'round')
                      .attr('title', $(button).attr('aria-label')) // Set the title attribute
                      .css('background-color', $(button).css('background-color')) // Set the background color
                      .append($(button).find('.product__color-swatch-tooltip')
                        .clone()
                        .addClass('product-swatches-options__item-tooltip') // Add custom class
                      )
                      // .on('click', function () {
                      //   var productHandle = $(this).data('product-handle'); // Get the product handle from the link

                      //   // Emit the "quick-view:open" event with the product details
                      //   window.emit("quick-view:open", null, {
                      //     type: "quick-view",
                      //     productUrl: `${window.location.origin}/collections/gaming/products/${productHandle}?view=quick-view`,
                      //     productMedia: "",
                      //     productBadges: "",
                      //     productTitle: "", // You can set this dynamically if needed
                      //   });
                      // });

                    liElement.append(link);
                    ulElement.append(liElement);
                  }
                });

                // Add the "+X" overflow button for additional swatches
                const additionalSwatchesCount = colorSwatchItems.length - 5;
                if (additionalSwatchesCount > 0) {
                  const overflowButton = $('<li></li>');
                  const overflowLink = $('<a class="product-swatches-options__item product-swatches-options__item--overflow show-product-quick-view-custom" aria-label="See all"></a>');
                  overflowLink.attr('data-product-handle', productHandle);
                  overflowLink.text(`+${additionalSwatchesCount}`).on('click', function () {
                    var productHandle = $(this).data('product-handle'); // Lấy product handle từ link

                    window.emit("quick-view:open", null, {
                      type: "quick-view",
                      productUrl: `${window.location.origin}/collections/gaming/products/${productHandle}?view=quick-view`,
                      productMedia: "",
                      productBadges: "",
                      productTitle: "",
                    });
                  });

                  overflowButton.append(overflowLink);
                  ulElement.append(overflowButton);
                }


                // Append the swatches wrapper to the outer container
                swatchesContainer.append(swatchesWrapper);

                // Append the swatches container to the footer of the closest card
                $(button).closest('.evm-ws-card').find('.ws-card__footer .evm-ws-addtocart').append(swatchesContainer);
              },
              error: function (xhr, status, error) {
                console.log("Error loading product data:", error);
              }
            });
          }
        });

        // owlItem.querySelector('.ws-card__footer .evm-ws-addtocart').appendChild(variantItem);
        // variantItem.style.display = 'none';

        handleQuickViewClick();
      }
    })
    .catch(error => console.error('Error fetching product variants:', error));
}

function createWishlistButton(dataId, variantId) {
  const wishlist = document.createElement("a");
  wishlist.href = "#";
  wishlist.className = "icon-wishlist-heart-empty wishlist-btn grid-wishlist-btn heart-wishlist-animation style_1";
  wishlist.setAttribute("data-wishlist", "");
  wishlist.setAttribute("data-gridhulklist", "");
  wishlist.setAttribute("data-added", "false");
  wishlist.setAttribute("data-proid", dataId);
  wishlist.setAttribute("data-varid", variantId);
  wishlist.setAttribute("style", "color: rgb(197, 6, 6); display: inline-block !important; right: unset; left: 10px;");
  wishlist.setAttribute("data-custom-wishlist-icon", "true");

  wishlist.innerHTML = `
        <div style="display: initial;" class="wishlist_btn_icon">
            <i class="heart-hulk-animation collection-icon" data-icon="outline" style="color: #d40d0d; font-size: 16px;">
                <i class="icon-wishlist-heart-empty"></i>
            </i>
        </div>
        <span>お気に入りに追加</span>
        <span class="count" data-layout="top_count" style="background-color: rgb(194, 9, 9); color: rgb(255, 255, 255);">0</span>
    `;
  return wishlist;
}

function createQuickViewButton(product) {
  const quickView = document.createElement("div");
  quickView.setAttribute("data-product-item-element-visible-only-for-mode", "grid");
  quickView.innerHTML = `
        <div class="product-item__floating-action-buttons">
            <button class="product-item__quick-view-button btn btn--rounded show-product-quick-view-custom product-item__disc-button" 
                    href="#" 
                    data-product-handle="${product.handle}"
                    title="Quick View" 
                    aria-label="Quick View">
                <span class="icon icon-quick-view" style="">
                    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M12.0875 15.6805C13.9032 15.6805 15.375 14.2086 15.375 12.393C15.375 10.5773 13.9032 9.10547 12.0875 9.10547C10.2719 9.10547 8.80005 10.5773 8.80005 12.393C8.80005 14.2086 10.2719 15.6805 12.0875 15.6805Z"
                            stroke="currentColor"
                            stroke-width="1.2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        ></path>
                        <path
                            d="M22.489 11.7954C21.3901 10.5555 17.0224 6 11.8 6C6.57759 6 2.20992 10.5555 1.11096 11.7954C1.03921 11.8827 1 11.9923 1 12.1053C1 12.2184 1.03921 12.3279 1.11096 12.4153C2.20992 13.6552 6.57759 18.2107 11.8 18.2107C17.0224 18.2107 21.3901 13.6552 22.489 12.4153C22.5608 12.3279 22.6 12.2184 22.6 12.1053C22.6 11.9923 22.5608 11.8827 22.489 11.7954V11.7954Z"
                            stroke="currentColor"
                            stroke-width="1.2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        ></path>
                    </svg>
                </span>
            </button>
        </div>
    `;
  return quickView;
}

function createVariantSwatches(product) {
  const variantItem = document.createElement("div");
  variantItem.setAttribute("data-product-item-element-visible-only-for-mode", "grid");
  variantItem.className = "product-swatches-container";

  let swatchesHTML = `
        <div class="product-swatches-options">
            <ul class="product-swatches-options__list ff-body fs-body-50">
    `;

  const maxVisible = 5;
  const totalVariants = product.variants.length;

  if (product.variants.length > 1) {
    product.variants.slice(0, maxVisible).forEach(variant => {
      const variantTitle = variant.title !== 'Default Title' ? variant.title : product.title;

      swatchesHTML += `
                <li>
                    <a href="${window.location.origin}/products/${product.handle}?view=quick-view" 
                       class="product-swatches-options__item show-product-quick-view-custom"
                       data-swatch-shape="round" 
                       data-product-handle="${product.handle}"
                       title="${variantTitle}" 
                       style="background-color: ">
                        <label class="product-swatches-options__item-tooltip ff-body fs-body-75" role="tooltip">
                            ${variantTitle}
                        </label>
                    </a>
                </li>
            `;
    });
  }

  if (totalVariants > maxVisible) {
    const hiddenCount = totalVariants - maxVisible;
    swatchesHTML += `
            <li>
                <a class="show-product-quick-view-custom product-swatches-options__item product-swatches-options__item--overflow" 
                   data-swatch-shape="round" 
                   title="See all" 
                   data-product-handle="${product.handle}"
                   aria-label="See all">
                +${hiddenCount}
                </a>
            </li>
        `;
  }

  swatchesHTML += `
        </ul>
    </div>
    `;
  variantItem.innerHTML = swatchesHTML;
  return variantItem;
}

function handleQuickViewClick() {
  $('.show-product-quick-view-custom').off('click');
  $('.show-product-quick-view-custom').on('click', function (e) {
    e.preventDefault();
    e.stopPropagation();
    const productHandle = $(this).data('product-handle');
    const productVariants = $(this).attr('data-product-variant');
    console.log(productVariants);
    
    let productUrl = `${window.location.origin}/products/${productHandle}`;
    if (productVariants) {
      productUrl += `?variant=${productVariants}`;
    }
  
    window.emit("quick-view:open", null, {
      type: "quick-view",
      productUrl: productUrl,
      productMedia: "",
      productBadges: "",
      productTitle: "",
    });
  });
}

// function loadProductData(productHandle, owlItem) {
//   const productUrl = `${window.location.origin}/products/${productHandle}?view=quick-view`;

//   $.ajax({
//     url: productUrl,
//     method: 'GET',
//     success: function (response) {
//       const colorSwatches = $(response).find('.product__color-swatches--inner');
//       if (colorSwatches.length) {
//         $('#div-variant-color').append(colorSwatches);
//       }
//     },
//     error: function (xhr, status, error) {
//       console.error("Error fetching product data:", error);
//     }
//   });
// }

$(document).ready(function () {
    $(".product-item__meta").hover(
        function () {
            let $productItem = $(this).closest(".product-item");
            $productItem.addClass("disabled");
        },
        function () {
            let $productItem = $(this).closest(".product-item");
            $productItem.removeClass("disabled");
        }
    );
});

